<template>
  <div class="yCenter">
    <div v-bind:style="{ width: getWidth('saleDate') }" class="colStyle px-1">
      {{ items.saleDate }}
    </div>
    <div v-bind:style="{ width: getWidth('customerId') }" class="colStyle px-1">
      {{ items.customer.rep }}
    </div>
    <div v-bind:style="{ width: getWidth('userId') }" class="colStyle px-1">
      {{ getUserName(items.user) }}
    </div>
    <div v-bind:style="{ width: getWidth('amount') }" class="colStyle px-1">
      {{
        maskText(
          getAmount(items),
          authority.isAdmin || authority.isUser || authority.isPartTime
        )
      }}
    </div>

    <!-- ステータス -->
    <div class="button-wrapper">
      <div class="button-line1-wrapper yCenter font-weight-bold ma-2">
        <template v-if="items.isCooperate">
          <span
            class="primary--text statusNameStyle mr-1"
            v-if="orderConfirmed"
          >
            {{ $t('order.order_order-confirmed') }}
          </span>
          <span class="error--text statusNameStyle mr-1" v-else>
            {{ $t('order.order_order-not-confirmed') }}
          </span>
          <NormalButton
            v-if="!orderConfirmed"
            :text="$t('order.order_order-confirm')"
            class="mr-2"
            btnClass="pa-2"
            height="32px"
            @click="onClickOrderConfirm(buttonType.ORDER_CONFIRM)"
          />
          <NormalButton
            v-else
            :text="$t('order.order_order-cancel-confirmed')"
            class="mr-2"
            btnClass="pa-2"
            height="32px"
            @click="onClickCancelConfirm(buttonType.ORDER_CONFIRM)"
          />
          <OrderIncompleteDialog
            v-model="order.dialog"
            :title="$t('order.order_incomplete-notification')"
            width="80%"
            :recItems="items"
            @complete="orderComplete"
          />
          <NormalButton
            :text="$t('order.order_incomplete-notification')"
            class="mr-2"
            btnClass="pa-2"
            height="32px"
            color="white"
            textColor="thinText--text"
            :outlined="true"
            @click="
              onClickOrderIncompleteNotification(
                buttonType.ORDER_INCOMPLETE_NOTIFICATION
              )
            "
          />
          <ShipDeliveryDialog
            v-model="shipDelivery.dialog"
            :title="$t('sale.ship_ship-delivery-notification')"
            width="80%"
            :recItems="items"
            :dialogReload="shipDelivery.dialog.dialogReload"
            @complete="completeShipmentDelivery"
          />
          <NormalButton
            :text="$t('sale.ship_ship-delivery-notification')"
            class="mr-2"
            btnClass="pa-2"
            height="32px"
            color="white"
            textColor="thinText--text"
            :outlined="true"
            @click="onClickShipDelivery(buttonType.SHIP_DELIVERY)"
          />
        </template>
      </div>
      <div class="button-line2-wrapper yCenter font-weight-bold ma-2">
        <span class="yCenter operationAreaStyle mr-1">
          <span class="primary--text statusNameStyle mr-1">
            {{
              items.paymentDate
                ? $t('payment.payment_already-sale-payment')
                : $t('payment.payment_not-sale-payment')
            }}
          </span>
          <NormalButton
            v-if="buttonStatus.isValid && authority.isAdmin"
            :text="$t('sale.sale_sale-payment-operate')"
            btnClass="pa-2"
            height="32px"
            :disabled="buttonStatus.isComplete"
            @click="payment.dialog.dialog = true"
          />
        </span>
        <DepositDialog
          v-model="payment.dialog"
          :title="$t('sale.sale_sale-payment-operate')"
          width="80%"
          :recItems="items"
          @complete="paymentcomplete()"
        />

        <span class="yCenter operationAreaStyle mr-1">
          <span class="primary--text statusNameStyle mr-1">
            {{
              items.shipDate
                ? $t('ship.ship_already-ship')
                : $t('ship.ship_not-ship')
            }}
          </span>
          <NormalButton
            v-if="buttonStatus.isValid"
            :text="$t('sale.sale_ship-operate')"
            btnClass="pa-2"
            height="32px"
            :disabled="buttonStatus.isComplete"
            @click="onClickCommon('ship')"
          />
        </span>

        <span class="yCenter operationAreaStyle mr-1">
          <span class="primary--text statusNameStyle mr-1">
            {{ getCompleteStatus(items) }}
          </span>
          <template v-if="buttonStatus.isValid">
            <NormalButton
              v-if="this.buttonStatus.isComplete && authority.isAdmin"
              :text="$t('order.order_complete-cancellation')"
              btnClass="pa-2"
              height="32px"
              @click="onClickComplete()"
            />
            <NormalButton
              v-else-if="!this.buttonStatus.isComplete && authority.isAdmin"
              :text="$t('sale.sale_sale-operation')"
              btnClass="pa-2"
              height="32px"
              @click="onClickComplete()"
            />
          </template>
        </span>
        <CompleteDialog
          v-model="complete.dialog"
          @complete="completeMethod"
          :title="$t('sale.sale_sale-operation')"
          :noName="$t('sale.sale_order')"
          :noValue="items.transaction.controlNumber"
          :dateName="$t('sale.sale_sale-completion')"
          :buttonName="$t('sale.sale_sale-completion')"
        />
        <NormalButton
          :text="$t('storage.storage_status-history')"
          class="mr-2"
          btnClass="pa-2"
          height="32px"
          color="white"
          textColor="thinText--text"
          :outlined="true"
          @click="statusHistory.dialog.dialog = true"
        />
        <StatusHistoryDialog
          v-model="statusHistory.dialog"
          :pageType="pageType"
          :tables="statusHistory.tables"
          itemKey=""
        />
        <NormalButton
          :text="$t('common.input_sale-details')"
          class="mr-2"
          btnClass="pa-2"
          height="32px"
          color="white"
          textColor="thinText--text"
          :outlined="true"
          @click="onClickCommon('salesDetail')"
        />

        <BulkOperationDocunents
          v-if="!authority.isOutsideStaff"
          @submit="selectedDocumentsPulldown"
          :isRowInfo="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { saleUtil, productMovesUtil, commonUtil } from '@/util'
import {
  CompleteDialog,
  StatusHistoryDialog,
  DepositDialog
} from '@/components/layouts/Dialogs'
import pageCommonMethods from '../script'
import NormalButton from '@/components/items/Buttons/NormalButton'
import BulkOperationDocunents from './BulkOperationDocunents'
import { BigNumber } from 'bignumber.js'
import OrderIncompleteDialog from '@/components/layouts/Dialogs/MultipleArea/OrderIncompleteDialog/OrderIncompleteDialog'
import ShipDeliveryDialog from '@/components/layouts/Dialogs/MultipleArea/ShipDeliveryDialog/ShipDeliveryDialog'
import { saleStatusHistory } from '@/config'

const BUTTON_TYPE = {
  ORDER_CONFIRM: 1,
  ORDER_INCOMPLETE_NOTIFICATION: 2,
  SHIP_DELIVERY: 3
}
export default {
  components: {
    ShipDeliveryDialog,
    OrderIncompleteDialog,
    NormalButton,
    CompleteDialog,
    StatusHistoryDialog,
    DepositDialog,
    BulkOperationDocunents
    // SalesDetailDialog
  },
  props: {
    headers: { default: [] },
    items: { default: [] }
  },
  data: () => ({
    pageType: 'Sales',
    recKeyIdName: 'saleId',

    rowDialogMethodCommonName: 'rowDialogMethodCommon',

    buttonStatus: {
      isComplete: false,
      isValid: true
    },

    statusHistory: {
      dialog: {
        dialog: false
      },
      tables: [
        {
          title: { default: '' },
          items: { default: [] },
          itemKey: { default: '' }
        }
      ]
    },
    complete: {
      dialog: {
        dialog: false,
        data: {
          id: '',
          date: ''
        }
      }
    },
    ship: {
      pageInfoData: {}
    },
    payment: {
      dialog: {
        dialog: false
      }
    },
    order: {
      dialog: {
        dialog: false
      }
    },
    shipDelivery: {
      dialog: {
        dialog: false,
        rowItems: {},
        pageInfoData: {},
        dialogReload: 0
      }
    },
    salesDetail: {
      dialog: {
        dialog: false
      },
      pageInfoData: {}
    },
    isConfirmed: false,
    isShipped: false,
    buttonType: BUTTON_TYPE
  }),
  computed: {
    ...mapGetters('User', ['authority']),
    orderConfirmed() {
      return (
        this.items.orderStatus !==
        saleStatusHistory.CUSTOMER_ORDER_STATUS_HISTORY.CONFIRMING
      )
    }
  },
  watch: {
    items: {
      deep: true,
      handler(newVal, oldVal) {
        this.ini()
      }
    }
  },
  created() {
    this.ini()
  },
  methods: {
    ...mapActions('Sale', [
      'registerSaleComplete',
      'cancelSaleComplete',
      'confirmOrder',
      'cancelConfirmOrder'
    ]),
    ...mapActions('Common', ['setIsLoading']),
    ...mapGetters('Order', ['getOrderIncompleteListFromState']),
    ...mapGetters('Ship', ['getShipDeliveryListFromState']),
    ...mapGetters('Sale', ['getSaleListFromState']),

    ini() {
      this.buttonStatus = {
        isComplete:
          this.items.status == 1 && this.items.compDate ? true : false,
        isValid: this.items.status !== 99
      }

      this.complete.dialog.data.id = this.items[this.recKeyIdName]
      this.statusHistory.tables =
        pageCommonMethods.methods.createStatusHistoryItems(
          saleUtil.getStatusHistoryTypeList(),
          this.items.saleStatusHistories,
          ''
        )
    },
    getCompleteStatus(rec) {
      if (!this.buttonStatus.isValid) return this.$t('order.order_invalid')
      return this.buttonStatus.isComplete
        ? this.$t('sale.sale_completion')
        : this.$t('order.order_unfinished')
    },

    getWidth(value) {
      const obj = this.headers.find((ele) => ele.value === value)
      return obj ? obj.width : '100px'
    },
    getUserName(user) {
      return user ? user.lastName + user.firstName : '-'
    },
    getAmount(rec) {
      const ret = productMovesUtil.getTotalAmountAndUnit(
        rec.productMoves,
        rec.currencyId
      )
      const addAmount = BigNumber(
        Number(rec.consumptionTax10) +
          Number(rec.consumptionTax8) +
          Number(rec.comission)
      )
        .minus(Number(rec.discount))
        .toNumber()
      const amount = BigNumber(ret.amount).plus(addAmount).toNumber()

      return commonUtil.formatPrice(amount).toLocaleString() + ret.unit
    },

    paymentcomplete() {
      this.payment.dialog.dialog = false
      this.pageReload()
    },
    orderComplete() {
      this.order.dialog.dialog = false
      this.pageReload()
    },

    async completeMethod() {
      this.setIsLoading(true)
      const isSucceed = await this.registerSaleComplete(
        this.complete.dialog.data
      )
      if (isSucceed) {
        this.complete.dialog.dialog = false
        this.pageReload()
      }
      this.setIsLoading(false)
    },

    onClickCommon(type) {
      this.$emit(this.rowDialogMethodCommonName, type, [
        this.items,
        this[type].pageInfoData
      ])
    },

    // onClickShip() {
    //   this.$emit(this.rowDialogMethodCommonName, 'ship', [
    //     this.items,
    //     this.ship.pageInfoData
    //   ])
    // },
    async onClickComplete() {
      if (!this.buttonStatus.isComplete) {
        this.complete.dialog.dialog = true
        return
      }
      if (!confirm(this.$t('sale.sale_restore-sale-question'))) return
      const isSucceed = await this.cancelSaleComplete(this.complete.dialog.data)
      if (isSucceed) {
        alert(this.$t('common.common_saved-alert'))
        this.pageReload()
      }
    },
    pageReload() {
      this.$emit(this.rowDialogMethodCommonName, 'reload')
    },
    selectedDocumentsPulldown(type) {
      this.$emit('onClickLedgerSheet', type, this.items)
    },
    onClickOrderConfirm(type) {
      const isValid = this.validateButton(type)
      if (!isValid) {
        return
      }
      this.showOrderConfirm()
    },
    onClickCancelConfirm(type) {
      const isValid = this.validateButton(type)
      if (!isValid) {
        return
      }
      this.showCancelOrderConfirm()
    },
    onClickOrderIncompleteNotification(type) {
      const isValid = this.validateButton(type)
      if (!isValid) {
        return
      }
      this.showOrderIncompleteNotification()
    },
    onClickShipDelivery(type) {
      const isValid = this.validateButton(type)
      if (!isValid) {
        return
      }
      this.showShipDeliveryDialog()
    },
    async showOrderConfirm() {
      if (confirm(this.$t('order.order_confirm-order-question'))) {
        // send api
        const isSucceed = await this.confirmOrder(this.items.saleId)
        if (isSucceed) {
          this.pageReload()
        }
      }
    },
    async showCancelOrderConfirm() {
      if (confirm(this.$t('order.order_cancel-order-question'))) {
        // send api
        const isSucceed = await this.cancelConfirmOrder(this.items.saleId)
        if (isSucceed) {
          this.pageReload()
        }
      }
    },
    showOrderIncompleteNotification() {
      this.order.dialog.dialog = true
    },
    showShipDeliveryDialog() {
      this.shipDelivery.dialog.dialog = true
    },
    completeShipmentDelivery() {
      this.shipDelivery.dialog.dialog = false
      this.pageReload()
    },
    validateButton(type) {
      let isValid = true
      if (type === BUTTON_TYPE.ORDER_CONFIRM) {
        if (this.items.incompleteOrderExists) {
          alert(this.$t('common.common_not-confirmed-by-incomplete-order'))
          isValid = false
        } else if (this.items.shipDeliveryExists) {
          alert(this.$t('common.common_not-unconfirm-by-shipment-existed'))
          isValid = false
        }
      } else if (type === BUTTON_TYPE.ORDER_INCOMPLETE_NOTIFICATION) {
        if (
          this.items.orderStatus !==
          saleStatusHistory.CUSTOMER_ORDER_STATUS_HISTORY.CONFIRMING
        ) {
          alert(this.$t('common.common_not-notification-by-confirmed-order'))
          isValid = false
        }
      } else if (type === BUTTON_TYPE.SHIP_DELIVERY) {
        if (
          this.items.orderStatus ===
          saleStatusHistory.CUSTOMER_ORDER_STATUS_HISTORY.CONFIRMING
        ) {
          alert(this.$t('common.common_not-ship-by-not-confirm-order'))
          isValid = false
        } else if (
          this.items.orderStatus ===
          saleStatusHistory.CUSTOMER_ORDER_STATUS_HISTORY.SHIPPED
        ) {
          alert(this.$t('common.common_product-shipped'))
          isValid = false
        }
      }
      return isValid
    }
  }
}
</script>
<style lang="scss" scoped>
.colStyle {
  word-wrap: break-word;
}
.operationAreaStyle {
  width: 120px;
}
.statusNameStyle {
  width: 36px;
}
</style>
